import { render } from "./Admins.vue?vue&type=template&id=13bbd940&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"

import "./Admins.vue?vue&type=style&index=0&id=13bbd940&scoped=true&lang=css"
import "./Admins.vue?vue&type=style&index=1&id=13bbd940&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bbd940"]])

export default __exports__